import { withSvgIcon } from './withSvgIcon';

export const AlertWarning = withSvgIcon(
  <>
    <path
      d="M11.0154 3.54839C11.453 2.8172 12.547 2.8172 12.9846 3.54839L21.846 18.3548C22.2836 19.086 21.7366 20 20.8614 20H3.13861C2.26341 20 1.71641 19.086 2.15401 18.3548L11.0154 3.54839Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="16.4745" r="1.19995" fill="currentColor" />
    <path
      d="M10.8471 8.32833C10.8326 8.15343 10.9706 8.00342 11.1461 8.00342H12.874C13.0495 8.00342 13.1875 8.15343 13.173 8.32833L12.723 13.7283C12.71 13.8838 12.58 14.0034 12.424 14.0034H11.5961C11.4401 14.0034 11.3101 13.8838 11.2971 13.7283L10.8471 8.32833Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
